<template>
  <div class="opage">
    <HomePageTop />
    <div class="forgetPsd">
      <div class="changePasswordBox" v-if="step >= 3">
        <p class="userInfo">
          {{ $fanyi('电子邮箱认证') }}
        </p>
        <nav class="step">
          <div class="step_top">
            <div class="circle_box" :class="{ old: step > 3, active: step == 3 }"></div>
            <div class="split_line"></div>
            <div class="circle_box" :class="{ old: step > 4, active: step == 4 }"></div>
            <div class="split_line"></div>
            <div class="circle_box" :class="{ old: step > 5, active: step == 5 }"></div>
          </div>
          <div class="step_bot">
            <div class="text_box">
              <p>
                {{ $fanyi('身份验证') }}
              </p>

            </div>
            <div class="text_box">
              <p>
                {{ $fanyi('登录密码修改') }}
              </p>

            </div>
            <div class="text_box">
              <p>
                {{ $fanyi('更改成功') }}
              </p>

            </div>
          </div>

        </nav>
        <!-- 身份验证 -->
        <div class="identityVerification" v-if="step == 3">
          <el-form ref="emailFormRef" :rules="emailFormRules" :model="emailForm">
            <el-form-item :label="$fanyi('请输入邮箱') + '：'" prop="email" class="regerror">
              <div class="regInputBox">
                <div class="emali">

                  <el-input v-model="emailForm.email" :placeholder="$fanyi('请输入完整电子邮箱')"></el-input>
                </div>
                <span class="prompt" :class="{ inputError: inputError }">
                  {{ $fanyi('*如果邮箱输入错误，将无法发送验证码') }}
                </span>
              </div>
            </el-form-item>
            <el-form-item prop="regCode" :label="$fanyi('验证码') + '：'" class="regerror">

              <div class="regInputBox">
                <div class="label_box" v-if="showBtn" @click="sendVerificationCode">
                  {{ $fanyi('验证码获取') }}
                </div>
                <div class="regCodeBox">

                  <el-input v-model="emailForm.regCode" :placeholder="$fanyi('请输入验证码')"></el-input>
                  <button v-if="!showBtn" class="countdown">
                    {{ Countdown }} S
                  </button>
                </div>
              </div>
            </el-form-item>
          </el-form>
          <button class="nextBtn" @click="toPassword">
            {{ $fanyi('下一步') }}
          </button>
        </div>
        <!-- 密码修改 -->
        <div class="newPassWordBox" v-if="step == 4">
          <el-form ref="formRef" :rules="formRules" :model="newPassword">
            <el-form-item :label="$fanyi('新密码') + '：'" prop="one">
              <el-input v-model="newPassword.one" :placeholder="$fanyi('请输入新的密码')" @input="onePasswordChannelInputLimit"
                @focus="validateField('one', 'formRef')" @blur="validateField('one', 'formRef')" :type="passwordtype">
                <template slot="suffix">
                  <div class="eyes">
                    <img v-if="passwordtype == 'password'" @click="passwordtype = 'text'"
                      src="../../assets/newassets/login/password1.svg" alt="">
                    <img v-else @click="passwordtype = 'password'" src="../../assets/newassets/login/password2.svg"
                      alt="">
                  </div>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item :label="$fanyi('再次确认密码') + '：'" prop="two">
              <el-input v-model="newPassword.two" :placeholder="$fanyi('请再次输入密码')" @input="twoPasswordChannelInputLimit"
                @focus="validateField('two', 'formRef')" @blur="validateField('two', 'formRef')"
                :type="confirmpasswordtype">
                <template slot="suffix">
                  <div class="eyes">
                    <img v-if="confirmpasswordtype == 'password'" @click="confirmpasswordtype = 'text'"
                      src="../../assets/newassets/login/password1.svg" alt="">
                    <img v-else @click="confirmpasswordtype = 'password'"
                      src="../../assets/newassets/login/password2.svg" alt="">
                  </div>
                </template>
              </el-input>
            </el-form-item>
          </el-form>
          <button class="nextBtn" @click="next()">
            {{ $fanyi('下一步') }}
          </button>
        </div>
        <!-- 修改成功 -->
        <div class="ChangeSuccess" v-if="step == 5">
          <div class="ChangeSuccessOpt">
            <p class="messageBox">
              <img src="../../assets/newassets/login/success2.svg" alt="" />
              <span>{{ $fanyi('登录密码更改成功') }}</span>

            </p>
            <button class="nextBtn" @click="$fun.toPage('/')">
              {{ $fanyi('返回主页') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomePageTop from '../../components/head/HomePageTop.vue'
import Areacode from '../../utlis/mobilephoneareacode.js'
export default {

  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$fanyi('请再次输入密码')))
      } else if (value !== this.newPassword.one) {
        callback(new Error(this.$fanyi('密码输入不一致')))
      } else {
        callback()
      }
    }
    return {
      inputError: false,
      step: 3,
      login_name: '', //用户名
      approveType: 'email', //用户验证身份的方式
      showBtn: true, //发送验证码按钮控制
      Countdown: 60, //秒数

      regNext: false,

      passwordtype: 'password',
      confirmpasswordtype: 'password',
      newPassword: {
        one: '',
        two: '',
      },
      newPasswordTrue: {
        one: false,
        two: false,
      },
      formRules: {
        one: [
          {
            required: true,
            pattern: /^.{6,16}$/,
            message: this.$fanyi('请输入6-16位包含大小写字母和数字的密码'),
          },
        ],
        two: [
          {
            required: true,
            validator: validatePass2,
          },
        ],
      },
      // 邮箱表单
      emailForm: {
        email: '',
        regCode: ''
      },
      emailFormRules: {
        email: [
          {
            required: true,
            validator: this.validateEmail,
            trigger: 'blur'
          }
        ],
        regCode: [
          {
            required: true, message: this.$fanyi('请输入验证码'), trigger: 'blur'
          }
        ]
      }

    }
  },
  components: { HomePageTop },
  computed: {},
  created() { },
  methods: {
    //校验邮箱输入
    async validateEmail(rule, val, callback) {
      var emailRegExp = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (val == '') {
        this.inputError = true
        return callback(new Error(this.$fanyi('请输入您的邮箱地址')))
      } else {
        if (!emailRegExp.test(val)) {
          this.inputError = true
          return callback(new Error(this.$fanyi('邮箱格式错误')))
        }
      }
      //校验成功之后判断是否注册过邮箱
      let res = await this.$api.checkRegisterField({
        field: 'email',
        value: this.emailForm.email,
      })
      if (res.success == true) {
        this.inputError = true
        return callback(new Error(this.$fanyi('该邮箱未注册')))
      }

      this.inputError = false
      callback()
    },

    // 手动检验数据函数
    validateField(type, formRef) {
      if (this.newPassword[type])
        this.newPassword[type] = this.newPassword[type].trim()
      this.$refs[formRef].validateField(type, (v) => {

        if (v == '') {
          this.newPasswordTrue[type] = true
        } else {
          this.newPasswordTrue[type] = false
        }
        this.$forceUpdate()
      })
    },
    //校验密码成功 设置新密码
    forgetPasswordReset() {
      let datas = {
        password: this.newPassword.one,
        login_name: this.emailForm.email,
        verification: {
          number: this.emailForm.email,
          code: this.emailForm.regCode,
        },
      }
      this.$api.forgetPasswordReset(datas).then((res) => {
        if (res.success == true) {
          this.step++
        } else {
          this.$message.error('未查找到该账号，请核对后再尝试或联系客服处理');
          this.regNext = false
        }
      })
    },
    // 验证验证码
    checkVerificationCode() {
      this.$api
        .checkVerificationCode({
          occasion: 'forget',
          number: this.emailForm.email,
          code: this.emailForm.regCode,
        })
        .then((res) => {
          if (res.success == true) {
            this.step++
          } else {
            this.$message.warning(this.$fanyi('验证码错误'))
          }
        })
    },
    // 发送验证码
    sendVerificationCode() {
      if (!this.emailForm.email) {
        return this.$message.error(this.$fanyi('请先输入邮箱'))
      }
      var emailRegExp = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (!emailRegExp.test(this.emailForm.email)) {
        return this.$message.error(this.$fanyi('邮箱格式错误'))
      }
      if (this.emailForm.email && emailRegExp.test(this.emailForm.email) && this.inputError) {
        return this.$message.error(this.$fanyi('该邮箱未注册'))
      }

      let datas = {
        occasion: 'forget',
        tool: 'email',
        number: this.emailForm.email,
      }
      this.showBtn = false
      this.Countdown = 60
      this.$api.sendVerificationCode(datas).then((res) => {
        this.showBtn = true
        if (res.code != 0) return this.$message.error(this.$fanyi(res.msg))
        this.showBtn = false
        var timer = setInterval(() => {
          this.Countdown--
          if (this.Countdown <= 0) {
            this.showBtn = true
            this.Countdown = 60
            clearInterval(timer)
          }
        }, 1000)
      })
    },
    onePasswordChannelInputLimit(e) {
      this.newPassword.one = e.replace(/[^A-Za-z0-9~!@#$%^+-.]/g, '')
    },
    twoPasswordChannelInputLimit(e) {

      this.newPassword.two = e.replace(/[^A-Za-z0-9~!@#$%^+-.]/g, '')
    },
    //邮箱页面成功进入输入密码页面
    toPassword() {


      this.$refs.emailFormRef.validate((valid) => {
        if (valid) {


          //校验成功  验证验证码
          this.checkVerificationCode()
        }
      })
    },
    next() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.forgetPasswordReset()
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../css/mixin.scss';

.opage {
  background-color: #f6f6f6;
  padding: 40px 0;

  .forgetPsd {
    width: 840px;
    min-height: 583px;
    background: #ffffff;
    margin: 0 auto;
    border-radius: 20px;
    padding: 65px 180px;
    padding-bottom: 0;

    // 修改密码
    .changePasswordBox {

      // title
      .userInfo {
        font-weight: bold;
        font-size: 24px;
        color: #121212;

      }

      .step {
        margin: 44px 0 41px 0;

        .step_top {
          width: 95%;
          height: 30px;
          margin: auto;
          display: flex;
          align-items: center;


          .split_line {
            width: 100%;
            height: 3px;
            background: #F5F5F5;
          }

          .circle_box {
            flex-shrink: 0;
            width: 24px;
            height: 24px;
            background: #FFFFFF;
            border-radius: 50%;
            border: 2px solid #DFDFDF;
          }

          .old {
            width: 30px;
            height: 30px;
            background: #FFFFFF;
            border-radius: 50%;
            border: 3px solid #A6BAEB;
          }

          .active {
            width: 30px;
            height: 30px;
            background: #FFFFFF;
            border-radius: 50%;
            border: 3px solid #2052CE;


          }

        }

        .step_bot {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-top: 22px;

          .text_box {
            width: 113px;
            font-weight: 400;
            font-size: 14px;
            color: #121212;


          }

          .text_box:nth-child(1) {
            p {
              width: 84px;
            }
          }

          .text_box:nth-child(2) {

            display: flex;
            justify-content: center;

            p {
              width: 86px;
            }

          }

          .text_box:nth-child(3) {
            display: flex;
            justify-content: flex-end;

            p {
              width: 64px;
            }


          }
        }

      }

      >div {
        margin: 0 auto;
      }

      // 身份验证
      .identityVerification {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        /deep/ .el-form-item {
          margin-bottom: 30px;
        }

        /deep/ .el-form-item__label {
          width: 100%;
          display: flex;
          align-items: center;
          font-weight: 400;
          font-size: 16px;
          color: #121212;
          line-height: 20px;
          margin-bottom: 10px;
        }

        /deep/ .el-form-item__error {
          top: 87px;
          font-weight: normal;
          font-size: 14px;
          color: #D12A1D;
        }

        .regInputBox {
          width: 480px;
          margin: 0 auto;

          display: flex;
          flex-direction: column;
          position: relative;

          .label_box {
            position: absolute;
            right: 0;
            top: -40px;
            font-weight: 400;
            font-size: 14px;
            color: #2052CE;
            cursor: pointer;
          }

          &:last-child {
            margin-bottom: 0;
          }

          label {
            font-weight: normal;
            font-size: 16px;
            color: #121212;
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            span:nth-child(2) {
              font-weight: 400;
              font-size: 14px;
              color: #2052CE;
              cursor: pointer;
            }

          }

          /deep/ .el-input {

            background: #FFFFFF;
            margin-bottom: 10px;

            .el-input__inner {
              width: 480px;
              height: 56px;
              border-radius: 12px;
              border: 1px solid #DFDFDF;
              padding: 0 20px;
              font-size: 14px;

            }
          }

          .prompt {
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            line-height: 16px;
          }

          .inputError {
            margin-top: 14px;
          }

          .regCodeBox {
            position: relative;

            .countdown {
              position: absolute;
              right: 20px;
              top: 18px;
              font-size: 14px;
              color: #999999;
              line-height: 20px;


            }
          }
        }
      }

      // 输入新密码
      .newPassWordBox {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        .el-form-item,
        /deep/.el-form-item {
          width: 480px;
          display: flex;
          flex-direction: column;
          margin-bottom: 40px;

          .el-form-item__label {
            text-align: left;
            font-weight: normal;
            font-size: 16px;
            color: #121212;
            margin-bottom: 10px;
            line-height: 20px;

            &:before {
              content: '';
            }
          }

          .el-input {
            width: 480px;
            height: 56px;

            border-radius: 12px;
            border: 1px solid #DFDFDF;
          }


          .el-input__inner {
            width: 100%;
            height: 100%;
            border-radius: 12px;
            border: none;
            background-color: #fff;
          }

          .el-form-item__error {
            top: 60px;
            font-weight: normal;
            font-size: 14px;
            color: #D12A1D;
          }

          .el-input__suffix {
            right: 20px;
            width: 20px;
            display: flex;

            align-items: center;
            justify-content: center;

            .el-icon-view {
              font-size: 18px;
            }

            .eyes {
              display: flex;
              align-items: center;
              justify-content: center;

              :hover {
                cursor: pointer;
              }
            }
          }

        }

      }

      // 修改成功
      .ChangeSuccess {
        .ChangeSuccessOpt {
          .messageBox {
            display: flex;
            align-items: center;
            margin-top: 60px;
            margin-bottom: 80px;

            img {
              width: 30px;
              height: 30px;
              margin-right: 20px;
            }

            span {
              font-weight: normal;
              font-size: 18px;
              color: #121212;
            }
          }
        }
      }
    }
  }
}




//第三部开始的下一步按钮
.nextBtn {
  width: 480px;
  height: 56px;
  background: #D12A1D;
  border-radius: 12px;
  font-weight: normal;
  font-size: 18px;
  color: #FFFFFF;
  margin-bottom: 65px;

}
</style>
